import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22c67237"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home",
  "data-bs-theme": "light"
}
const _hoisted_2 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-container" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "taskWrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Create New Task from Task Template", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("p", null, " A Task template represents a repeatable task. When creating a new task from the template, the new task retains a reference to its template. Task templates are used within job templates to define the tasks needed for the job. ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Job Details", -1))
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "jobTemplateType" }, [
    /*#__PURE__*/_createTextVNode("Job Type"),
    /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*"),
    /*#__PURE__*/_createTextVNode(" : ")
  ])
], -1))
const _hoisted_14 = { class: "col" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select a Job", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Select a job to view details.", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Error: Unable to load job.", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "row my-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Job Name: ", -1))
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "row my-1" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Job Description: ", -1))
const _hoisted_29 = { class: "col" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Task Template Details", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = { class: "row my-1" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "templateType" }, [
    /*#__PURE__*/_createTextVNode("Template Type"),
    /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*"),
    /*#__PURE__*/_createTextVNode(": ")
  ])
], -1))
const _hoisted_37 = { class: "col" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select a template", -1))
const _hoisted_39 = ["value"]
const _hoisted_40 = {
  key: 0,
  class: "row"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Select a task template to view details.", -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { key: 2 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Error: Unable to load task template.", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { key: 3 }
const _hoisted_47 = { class: "row my-1" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Template Name: ", -1))
const _hoisted_49 = { class: "col" }
const _hoisted_50 = { class: "row my-1" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Template Description: ", -1))
const _hoisted_52 = { class: "col" }
const _hoisted_53 = { class: "row my-1" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Template Work Center: ", -1))
const _hoisted_55 = { class: "col" }
const _hoisted_56 = { class: "row my-1" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Template Cost Center: ", -1))
const _hoisted_58 = { class: "col" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Task Details", -1))
const _hoisted_63 = { class: "input-group mb-3" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 input-group-text" }, [
  /*#__PURE__*/_createTextVNode("Task Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_65 = ["onUpdate:modelValue"]
const _hoisted_66 = { class: "input-group mb-3" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 input-group-text" }, [
  /*#__PURE__*/_createTextVNode("Task Description "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_68 = ["onUpdate:modelValue"]
const _hoisted_69 = { class: "input-group mb-3" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-3 input-group-text" }, [
  /*#__PURE__*/_createTextVNode("Employee "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_71 = ["onUpdate:modelValue"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select an Employee", -1))
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "input-group mb-3" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 input-group-text" }, [
  /*#__PURE__*/_createTextVNode("Priority "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_76 = ["onUpdate:modelValue"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Priority", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Low", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Medium", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "High", -1))
const _hoisted_81 = [
  _hoisted_77,
  _hoisted_78,
  _hoisted_79,
  _hoisted_80
]
const _hoisted_82 = { class: "input-group mb-3" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "col-3 input-group-text",
  for: "expectedStartDate"
}, [
  /*#__PURE__*/_createTextVNode("Expected Start "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_84 = ["onUpdate:modelValue"]
const _hoisted_85 = { class: "input-group mb-3" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "col-3 input-group-text",
  for: "expectedConclusionDate"
}, [
  /*#__PURE__*/_createTextVNode("Expected Conclusion "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_87 = ["onUpdate:modelValue"]
const _hoisted_88 = ["onClick"]
const _hoisted_89 = ["disabled"]

import { Task, Job, TaskTemplate } from '@/types/Ops';
import { fetchAllTaskTemplates, fetchAllJobs, postToUrl } from '@/api/api';
import { useJobStore } from '@/stores/Jobs';
import { useEmployeeStore } from '@/stores/UserEmployee';
import { ref, watch, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateTaskFromTemplate',
  setup(__props) {

const route = useRoute();
const isCreatingTask = ref(false);
const TaskTemplateId = ref(parseInt(route.params.templateId as string));
const allJobs = ref<Job[]>([]);
const selectedJobId = ref<number | null>(null);
const errorMsg = ref('');
const employeeStore = useEmployeeStore();
const allTaskTemplates = ref<TaskTemplate[]>([]);
const selectedTaskTemplateId = ref<number | null>(null);

const job = ref<Job>({
  id: 0,
  name: '',
  description: '',
  build_order_reference: '',
  tasks: [],
  work_center: null,
  completed_by: '',
  status: '',
});

const tasks = ref<Task[]>([
  {
    id: 0,
    name: '',
    description: '',
    employees: null,
    assignedEmployee: null,
    expected_start: '',
    expected_concluded: '',
    priority: 2,
  }
]);

const template = ref<TaskTemplate>({
  id: 0,
  name: '',
  description: '',
  work_center: null,
  cost_center: null,
  job_template: 0,
  job_template_order: 0
});

watch(() => route.params, (nextParam, lastParam) => {
  TaskTemplateId.value = parseInt(nextParam.templateId as string);
});

const clearErrorMsg = () => {
  errorMsg.value = '';
};

onMounted(async () => {
  try {
    allJobs.value = await fetchAllJobs();
    allTaskTemplates.value = await fetchAllTaskTemplates();
    const jobStore = useJobStore();
    await jobStore.getAllJobs();
    await employeeStore.fetch();
  } catch (error) {
    console.error("Error fetching jobs:", error);
  }
});

const filteredEmployees = computed(() => {
  return employeeStore.employees?.map(employee => {
    let rolePrefix;
    if (employee.user.is_superuser) {
      rolePrefix = "AD"; // Admin
    } else if (employee.user.is_staff) {
      rolePrefix = "MA"; // Manager
    } else {
      rolePrefix = "EM"; // Employee
    }
    const displayName = `${rolePrefix} - ${employee.user.full_name}`;
    return {
      ...employee,
      rolePrefix,
      displayName,
    };
  }) || [];
});

const updateDisplayedJob = () => {
  const selectedJob = allJobs.value.find(t => t.id === selectedJobId.value);
  if (selectedJob) {
    job.value = selectedJob;
  }
};

const displayedJob = computed(() => {
  return selectedJobId.value
    ? job.value
    : {
      name: '',

    };
});

const updateDisplayedTaskTemplate = () => {
  const selectedTemplate = allTaskTemplates.value.find(t => t.id === selectedTaskTemplateId.value);
  if (selectedTemplate) {
    template.value = selectedTemplate;
  }
};

watch(selectedTaskTemplateId, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    updateDisplayedTaskTemplate();
  }
});

watch(selectedJobId, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    updateDisplayedJob();
  }
});

const resetTask = () => {
  tasks.value = [
    {
      id: 0,
      name: '',
      description: '',
      employees: null,
      value: '',
      work_center: null,
      cost_center: null,
      job: 0,
      started: undefined,
      started_by: 0,
      concluded: undefined,
      concluded_by: 0,
      successful: false,
      conclusion_notes: '',
      events: [],
      perpetual: false,
      task_template: 0,
      job_order: 0,
      task: undefined,
      completed: '',
      expected_start: '',
      expected_concluded: ''
    }
  ];
};

const addTask = () => {
  tasks.value.push({
    id: 0,
    name: '',
    description: '',
    employees: null,
    assignedEmployee: null,
    expected_start: '',
    expected_concluded: '',
    priority: 2,
  });
};


const removeTask = (index: number) => {
  tasks.value.splice(index, 1);
};

const isFormValid = computed(() => {
  return tasks.value.every(task =>
    (task.name?.trim() || '') &&
    (task.description?.trim() || '') &&
    (task.expected_start?.trim() || '') &&
    (task.expected_concluded?.trim() || '') &&
    task?.assignedEmployee &&
    selectedTaskTemplateId?.value
  );
});

const createTasks = async () => {
  if (!isFormValid.value) {
    errorMsg.value = 'Please fill out all required fields for each task.';
    return;
  }

  isCreatingTask.value = true;
  try {
    for (const task of tasks.value) {
      // console.log(task);
      const newTask = {
        name: task.name,
        description: task.description,
        employees: task.assignedEmployee ? [task.assignedEmployee] : [],
        job: selectedJobId.value,
        expected_start: task.expected_start,
        expected_concluded: task.expected_concluded,
        created_by: employeeStore.currentUser?.id,
        priority: task.priority,
      };

      await postToUrl(`/ops/api/create-task/${selectedTaskTemplateId.value}/`, newTask);
    }
    alert(`Task has been successfully created`);
  } catch (error) {
    alert('Error occurred while creating tasks.');
  } finally {
    isCreatingTask.value = false;
    resetTask();
  }
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isCreatingTask.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("span", _hoisted_14, [
          _withDirectives(_createElementVNode("select", {
            id: "jobTemplateType",
            class: "form-select",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedJobId).value = $event)),
            onChange: updateDisplayedJob,
            onInput: clearErrorMsg,
            placeholder: "Select a job to view details.",
            required: ""
          }, [
            _hoisted_15,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allJobs.value, (jt) => {
              return (_openBlock(), _createElementBlock("option", {
                key: jt.id,
                value: jt.id
              }, _toDisplayString(jt?.name), 9, _hoisted_16))
            }), 128))
          ], 544), [
            [_vModelSelect, selectedJobId.value]
          ]),
          (!selectedJobId.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
            : _createCommentVNode("", true)
        ])
      ]),
      (!job.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("span", _hoisted_26, _toDisplayString(job.value ? job.value.name : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("span", _hoisted_29, _toDisplayString(job.value ? job.value.description : ''), 1)
            ])
          ])),
      _hoisted_30,
      _hoisted_31,
      _hoisted_32,
      _hoisted_33,
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _createElementVNode("span", _hoisted_37, [
          _withDirectives(_createElementVNode("select", {
            id: "templateType",
            class: "form-select",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedTaskTemplateId).value = $event)),
            onChange: updateDisplayedTaskTemplate,
            style: {"--bs-bg-opacity":"0.9"},
            required: ""
          }, [
            _hoisted_38,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allTaskTemplates.value, (tmpl) => {
              return (_openBlock(), _createElementBlock("option", {
                key: tmpl.id,
                value: tmpl.id
              }, _toDisplayString(tmpl?.name), 9, _hoisted_39))
            }), 128))
          ], 544), [
            [_vModelSelect, selectedTaskTemplateId.value]
          ]),
          (!selectedTaskTemplateId.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
            : _createCommentVNode("", true)
        ])
      ]),
      (!template.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
        : (_openBlock(), _createElementBlock("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("span", _hoisted_49, _toDisplayString(template.value ? template.value.name : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("span", _hoisted_52, _toDisplayString(template.value ? template.value.description : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("span", _hoisted_55, _toDisplayString(template.value && template.value.work_center ? template.value.work_center.name : 'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _createElementVNode("span", _hoisted_58, _toDisplayString(template.value && template.value.cost_center ? template.value.cost_center.name : 'N/A'), 1)
            ])
          ])),
      _hoisted_59,
      _hoisted_60,
      _hoisted_61,
      _hoisted_62,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tasks.value, (task, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("h3", null, "Task " + _toDisplayString(index + 1), 1),
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _withDirectives(_createElementVNode("input", {
              class: "form-control task-name-input",
              type: "text",
              "onUpdate:modelValue": ($event: any) => ((task.name) = $event),
              required: ""
            }, null, 8, _hoisted_65), [
              [_vModelText, task.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _hoisted_67,
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control task-description-input",
              "onUpdate:modelValue": ($event: any) => ((task.description) = $event),
              required: ""
            }, null, 8, _hoisted_68), [
              [_vModelText, task.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": ($event: any) => ((task.assignedEmployee) = $event),
              class: "form-select",
              required: ""
            }, [
              _hoisted_72,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEmployees.value, (employee) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: employee.id,
                  value: employee.id
                }, _toDisplayString(employee.displayName), 9, _hoisted_73))
              }), 128))
            ], 8, _hoisted_71), [
              [_vModelSelect, task.assignedEmployee]
            ])
          ]),
          _createElementVNode("div", _hoisted_74, [
            _hoisted_75,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": ($event: any) => ((task.priority) = $event),
              class: "form-select",
              required: ""
            }, _hoisted_81, 8, _hoisted_76), [
              [_vModelSelect, task.priority]
            ])
          ]),
          _createElementVNode("div", _hoisted_82, [
            _hoisted_83,
            _withDirectives(_createElementVNode("input", {
              id: "expectedStartDate",
              "onUpdate:modelValue": ($event: any) => ((task.expected_start) = $event),
              type: "date",
              class: "form-control",
              required: ""
            }, null, 8, _hoisted_84), [
              [_vModelText, task.expected_start]
            ])
          ]),
          _createElementVNode("div", _hoisted_85, [
            _hoisted_86,
            _withDirectives(_createElementVNode("input", {
              id: "expectedConclusionDate",
              "onUpdate:modelValue": ($event: any) => ((task.expected_concluded) = $event),
              type: "date",
              class: "form-control",
              required: ""
            }, null, 8, _hoisted_87), [
              [_vModelText, task.expected_concluded]
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-danger remove-task-btn",
            onClick: ($event: any) => (removeTask(index))
          }, "Remove Task", 8, _hoisted_88)
        ]))
      }), 128)),
      _createElementVNode("button", {
        class: "btn btn-info add-task-btn",
        onClick: addTask
      }, "➕ Add Task"),
      _createElementVNode("button", {
        class: "btn btn-primary create-task-btn",
        onClick: createTasks,
        disabled: !isFormValid.value
      }, "Create Tasks", 8, _hoisted_89)
    ])
  ]))
}
}

})